import { render, staticRenderFns } from "./Trace.vue?vue&type=template&id=0050a735&scoped=true&"
import script from "./Trace.vue?vue&type=script&lang=js&"
export * from "./Trace.vue?vue&type=script&lang=js&"
import style0 from "../assets/less/filters.less?vue&type=style&index=0&id=0050a735&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050a735",
  null
  
)

export default component.exports